/**
 * Does the selected Enqueue-Schools mode actually honor "Skip already-rendered
 * files"?
 *
 * ONLY school-code mode does. The by_season and filenames modes send
 * intent:"reprocess", which regenerates into full-res-reprocessed -- a print
 * source ranked second only to full_res_pngs by ExportService::PreFlightAudit,
 * and where orders:prepare_on_hold routes on-hold orders. Those students are
 * already rendered and on_website by definition, so the server-side predicate
 * would answer "rendered" for essentially every file and skip 100% of the work,
 * silently stranding print orders. "Already reprocessed?" is a different
 * question (does the object exist in full-res-reprocessed?) that needs a batched
 * bucket index, not the DB predicate. See docs/pipeline_reprocessing_plan.md.
 *
 * This lives in ONE place because the admin view needs the same answer twice --
 * to grey out the checkbox, and to decide whether to warn before enqueuing --
 * and two hand-kept copies of the same rule is precisely the drift this
 * subsystem keeps getting bitten by (CLAUDE.md pipeline principle #1).
 *
 * @param {string[]} scodes    school codes entered (already split/filtered)
 * @param {string[]} filenames explicit file names entered (already split/filtered)
 * @returns {boolean} true when the run will skip already-rendered files
 */
export default function skipCompletedHonored(scodes, filenames) {
  const codes = Array.isArray(scodes) ? scodes : [];
  const files = Array.isArray(filenames) ? filenames : [];
  return codes.length > 0 && files.length === 0;
}
